import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { ExpandableObject } from '../../components/abstractObjects/ExpandableObject'
import { selectAllCountries } from '../countries/countriesSlice'
import { selectAllDevices } from '../devices/devicesSlice'
import { selectAllSupervisors } from '../supervisors/supervisorsSlice'
import Input from '../../components/abstractObjects/Input'
import { RadioYesNoNull } from '../../components/abstractObjects/RadioYesNo'
import { CheckBox } from '../../components/abstractObjects/CheckBox'
import { Grid, Box, Toolbar, AppBar } from '@material-ui/core'
import { SectionWithQuestionLabel, Label, SectionLabel, BasicLabel } from '../../components/abstractObjects/Label'
import { makeStyles } from '@material-ui/core/styles'
import { Date, DateTime, ToShortDate } from '../../components/abstractObjects/Date'
import { MultipleSelect } from '../../components/abstractObjects/MultipleSelect'
import ReferBackHistory from './referBackHistoryForm'
import * as Constants from '../constants'
import { fetchVar, selectVarById } from './varSlice'
import { Translation } from '../../features/translations/getTranslation'
import { VarAttachmentsView } from '../varAttachment/attachmentsList';
import { VarBatchPackingsView } from '../varBatchPackings/varBatchPackingsList';
import { selectAllVarFieldAttachments } from '../varFieldAttachments/varFieldAttachmentsSlice';

const useStyles = makeStyles((theme) => ({
    buttonMobile: {
        color: '#FFF',
        border: 'none',
        margin: '0 auto',
        padding: '0 10px'
    },
    buttonDesktop: {
        color: '#FFF',
        border: 'none'
    },
    appBar: {
        top: 'auto',
        bottom: 0,
    },
    sectionDesktopTop: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline-flex',
        },
    },
    sectionDesktopBottom: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'initial',
        },
    },
    sectionMobile: {
        display: 'initial',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    button: {
        width: '100%',
        height: '100%',
        color: 'white !important',
        fontSize: '1.6rem',
        fontWeight: 'bold',
        backgroundColor: '#1CABE2',
        borderRadius: 5,
        paddingTop: "1.5%",
        textAlign: "center"
    }
}));

let VarForm = ({ varId }) => {
    const classes = useStyles();
    const history = useHistory()

    const varx = useSelector((state) => selectVarById(state, varId))
    const countries = useSelector(selectAllCountries)
    const devices = useSelector(selectAllDevices)
    const varFieldAttachments = useSelector(selectAllVarFieldAttachments)

    var country = countries.find(x => x.Id === varx.CountryId)
    //const VarAttachmentsCount = varx.VarAttachments.length
    const supervisors = useSelector(selectAllSupervisors)
    var supervisor = supervisors.find(x => x.Id === varx.SupervisorId)

    const [expandGeneral, setExpandGeneral] = useState(true)
    const [expandVarPoLines, setExpandVarPoLines] = useState(true)
    const [expandVarPoLines2, setExpandVarPoLines2] = useState(true)
    const [expandQuestionnaire, setExpandQuestionnaire] = useState(true)
    const [expandInspector, setExpandInspector] = useState(true)
    const [expandSupervisor, setExpandSupervisor] = useState(true)
    const [expandReferBackHistory, setExpandReferBackHistory] = useState(true)

    const poLineInfos = [], poLineInfosWithCorrectedQty = [];
    varx.VarPoLines.forEach((VarPoLine, index) => {
        poLineInfos.push(
            <div key={index}>
                <Label text="DELIVERY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryNumber} /><br />
                <Label text="ITEM" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.Poline} /><br />
                <Label text="DESCRIPTION" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.VaccineDescription} /><br />
                <Label text="DELIVERY_QUANTITY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryQuantity} /><br />
                <hr />
            </div>
        );
        poLineInfosWithCorrectedQty.push(
            <div key={index}>
                <Label text="DELIVERY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryNumber} /><br />
                <Label text="ITEM" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.Poline} /><br />
                <Label text="DESCRIPTION" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.VaccineDescription} /><br />
                <Label text="DELIVERY_QUANTITY" style={{ fontWeight: "bold" }} /> <Label text={VarPoLine.DeliveryQuantity} /><br />
                <Label text="DELIVERY_QUANTITY_CORRECTED" style={{ fontWeight: "bold" }} /><Label text={VarPoLine.DeliveryQuantityCorrected} /><br />
                <hr />
            </div>
        );
    });

    const batchPackingsQuestion7 = VarBatchPackingsView({ label: "BATCH_PACKINGS", varId });
    const goodConditionAttachmentQuestion8 = VarAttachmentsView({ label: varFieldAttachments.find(x => x.Id == "GoodConditionOfBoxesOnArrivalUrlAttachment")?.FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "GoodConditionOfBoxesOnArrivalUrlAttachment" });
    const labelsAttachedToBoxesAttachmentQuestion9 = VarAttachmentsView({ label: varFieldAttachments.find(x => x.Id == "LabelsAttachedToBoxesUrlAttachment")?.FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "LabelsAttachedToBoxesUrlAttachment" });
    const thereAlarmsOrExcursionsTempAttachmentPdfQuestion12 = VarAttachmentsView({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPdf")?.FieldName ?? "Please upload the PDF files from the device", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPdf" });
    const thereAlarmsOrExcursionsTempAttachmentAlarmQuestion12 = VarAttachmentsView({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentAlarm")?.FieldName ?? "Fill in electronic Device Alarm Report Form", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentAlarm" });
    const thereAlarmsOrExcursionsTempAttachmentPicturesQuestion12 = VarAttachmentsView({ label: varFieldAttachments.find(x => x.Id == "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPictures")?.FieldName ?? "Attach pictures", varId, varFieldAttachmentId: "ThereAlarmsOrExcursionsTemperatureUrlAttachmentPictures" });

    var caller = history.location.pathname.split('/')[1]
    var editButton =
        (varx.StatusId === Constants.VAR_STATUS_UPLOADED || varx.StatusId === Constants.VAR_STATUS_UNAPPROVED ||
            ((varx.StatusId === Constants.VAR_STATUS_SUBMITTED || varx.StatusId === Constants.VAR_STATUS_REFERBACKSD) && varx.ImSupervisor)) && !varx.ImViewer &&
        caller === "active"
    return (
        <div>
            {editButton ? <Link to={`/${caller}/edit/${varx.Id}`} className={`${classes.sectionDesktopTop} ${classes.button}`} style={{ textDecoration: "none", marginBottom: 10, width: "unset", height: "unset", padding: "3px 20px" }}><BasicLabel text="EDIT" /></Link> : ""}
            <span style={{ float: "right" }}><BasicLabel text="UPDATED" /> {ToShortDate(varx.UpdatedServerDate)} {varx.UpdatedServerDate.substring(11, 16)}</span>
            <br />
            <ExpandableObject name="GENERAL_INFORMATION" onChange={() => setExpandGeneral(!expandGeneral)} expanded={expandGeneral}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="COUNTRY" /><Input value={country ? country.CountryName : ''} readonly />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="AIRPORT_OF_DESTINATION" /><Input value={varx.ReceivingPort} readonly />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="PO_NUMBER" /><Input value={varx.Pono} readonly />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="AWB No" /><Input value={varx.Awbno} readonly />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="CONSIGNEE" /><Input value={varx.Consignee.ConsigneeName} readonly />
                    </Grid>
                    {/*<Grid item xs={12} sm={6} md={6} mb="0.5rem">*/}
                    {/*    <Label text="Estimated Time Of Arrival" />*/}
                    {/*    <Date value={varx.EstimatedDateOfArrival ? varx.EstimatedDateOfArrival : ToShortDate(new window.Date())} readonly />*/}
                    {/*</Grid>*/}
                    <Grid item xs={12} sm={6} md={6} mb="0.5rem">
                        <Label text="MANUFACTURER" />
                        <Input value={varx.Supplier.SupplierName} readonly />
                    </Grid>
                    {/*<Grid item xs={12} sm={6} md={6} mb="0.5rem">*/}
                    {/*    <Label text="Status" /><Input value={varx.Status.StatusDescription} readonly />*/}
                    {/*</Grid>*/}
                </Grid>
                <div>
                    <ExpandableObject class="secondaryExpandable" name="DELIVERY_QUANTITY_DESCRIPTION" onChange={() => setExpandVarPoLines(!expandVarPoLines)} expanded={expandVarPoLines}>
                        {poLineInfos}
                    </ExpandableObject>
                </div>
            </ExpandableObject>
            <ExpandableObject name="QUESTIONNAIRE" onChange={() => setExpandQuestionnaire(!expandQuestionnaire)} expanded={expandQuestionnaire}>
                <SectionLabel text="QUESTION_1" />
                <RadioYesNoNull text="LABEL_1" value={varx.IsAllAboveInformationCorrect} aria-label="IsAllAboveInformationCorrect" readonly />
                {!varx.IsAllAboveInformationCorrect ? (
                    <div>
                        <Label text="LABEL_1_2" style={{ fontWeight: "bold" }} /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.AirportOfDestinationIncorrect} aria-label="AirportOfDestinationIncorrect" disabled /><Label text="AIRPORT_OF_DESTINATION" />
                        {varx.AirportOfDestinationIncorrect ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={varx.AirportOfDestinationCorrected ? varx.AirportOfDestinationCorrected : ''} aria-label="AirportOfDestinationCorrected" readonly /></React.Fragment> : null}<br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PonoIncorrect} aria-label="PonoIncorrect" disabled /><Label text="PO_NUMBER" />
                        {varx.PonoIncorrect ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={varx.PonoCorrected ? varx.PonoCorrected : ''} aria-label="PonoCorrected" readonly /></React.Fragment> : null}<br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.AwbNoIncorrect} aria-label="AwbNoIncorrect" disabled /><Label text="AWB No" />
                        {varx.AwbNoIncorrect ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={varx.AwbNoCorrected ? varx.AwbNoCorrected : ''} aria-label="AwbNoCorrected" readonly /></React.Fragment> : null}<br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.DeliveryInformationIncorrect} aria-label="DeliveryInformationIncorrect" disabled /><Label text="DELIVERY_INFORMATION" /><br /><br />
                        {varx.DeliveryInformationIncorrect ?
                            <ExpandableObject class="secondaryExpandable" name="DELIVERY_INFORMATION" onChange={() => setExpandVarPoLines2(!expandVarPoLines2)} expanded={expandVarPoLines2}>
                                {poLineInfosWithCorrectedQty}
                            </ExpandableObject> : null}
                        <Label text="COMMENT_LABEL" /><Input multiline value={varx.AllAboveInformationCorrectComment} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionWithQuestionLabel text="QUESTION_2" questionText="TOOLTIP_2" />
                <RadioYesNoNull text="LABEL_2" value={varx.IsShipmentInfoGood} aria-label="IsShipmentInfoGood" readonly />
                {!varx.IsShipmentInfoGood ? (
                    <div>
                        <br /><Label style={{ fontWeight: "bold" }} text="COMPLAINT_1" /> <a style={{ fontWeight: "bold", color: "blue" }} target="_blank" href="https://cica.unicef.org">{Translation.t("COMPLAINT_2")}</a> <Label style={{ fontWeight: "bold" }} text="COMPLAINT_3" /><br />
                    </div>
                ) : (<div></div>)}
                <SectionWithQuestionLabel text="QUESTION_3" questionText="TOOLTIP_3" /><br />
                <RadioYesNoNull text="LABEL_3" value={varx.IsPreAdviceReceivedInTime} aria-label="IsPreAdviceReceivedInTime" readonly />
                {!varx.IsPreAdviceReceivedInTime ? (
                    <div>
                        <Label text="LABEL_3_2" /><Input value={varx.DaysPassedBetweenReceiptAndShipment} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_4" />
                <RadioYesNoNull text="LABEL_4" value={varx.IsPreAdviceWithAllDocs} aria-label="IsPreAdviceWithAllDocs" readonly />
                {!varx.IsPreAdviceWithAllDocs ? (
                    <div>
                        <Label text="LABEL_4_6_2" style={{ fontWeight: "bold" }} /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceInvoice} aria-label="PreAdviceInvoice" disabled /><Label text="INVOICE" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdvicePackingList} aria-label="PreAdvicePackingList" disabled /><Label text="PACKING_LIST" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceBatchCertificate} aria-label="PreAdviceBatchCertificate" disabled /><Label text="RELEASE_CERTIFICATE" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceCertificateOfOrigin} aria-label="PreAdviceCertificateOfOrigin" disabled /><Label text="CERTIFICATE_OF_ORIGIN" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceCertificateOfConformity} aria-label="PreAdviceCertificateOfConformity" disabled /><Label text="CERTIFICATE_OF_CONFORMITY" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceCertificateOfAnalysis} aria-label="PreAdviceCertificateOfAnalysis" disabled /><Label text="CERTIFICATE_OF_ANALYSIS" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PreAdviceOtherCertificate} aria-label="PreAdviceOtherCertificate" disabled /><Label text="OTHER_SPECIFY" /><br /><br />
                        <Label text="COMMENT_LABEL_4_6" /><Input multiline value={varx.PreAdviceAdditionalComments} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_5" />
                <RadioYesNoNull text="LABEL_5" value={varx.IsFlightArrivedOnTime} aria-label="IsFlightArrivedOnTime" readonly />
                {!varx.IsFlightArrivedOnTime ? (
                    <div>
                        <Label text="LABEL_5_2" /><Date value={varx.ActualDateOfArrival ? varx.ActualDateOfArrival : ToShortDate(new window.Date())} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_6" />
                <RadioYesNoNull text="LABEL_6" value={varx.IsAtDeliveryReceivedAllRequiredDocuments} aria-label="IsAtDeliveryReceivedAllRequiredDocuments" readonly />
                {!varx.IsAtDeliveryReceivedAllRequiredDocuments ? (
                    <div>
                        <Label text="LABEL_4_6_2" style={{ fontWeight: "bold" }} /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.Invoice} aria-label="Invoice" disabled /><Label text="INVOICE" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.PackingList} aria-label="PackingList" disabled /><Label text="PACKING_LIST" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.ReleaseCertificate} aria-label="ReleaseCertificate" disabled /><Label text="RELEASE_CERTIFICATE" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.CertificateOfOrigin} aria-label="CertificateOfOrigin" disabled /><Label text="CERTIFICATE_OF_ORIGIN" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.CertificateOfConformity} aria-label="CertificateOfConformity" disabled /><Label text="CERTIFICATE_OF_CONFORMITY" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.CertificateOfAnalysis} aria-label="CertificateOfAnalysis" disabled /><Label text="CERTIFICATE_OF_ANALYSIS" /><br /><br />
                        <CheckBox style={{ paddingRight: "10px" }} value={varx.OtherCertificate} aria-label="OtherCertificate" disabled /><Label text="OTHER_SPECIFY" /><br /><br />
                        <Label text="COMMENT_LABEL_4_6" /><Input multiline value={varx.ShipmentDocumentComments} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_7" />
                <RadioYesNoNull text="LABEL_7" value={varx.IsBatchesMatchedWithPackingList} aria-label="IsBatchesMatchedWithPackingList" readonly />
                {!varx.IsBatchesMatchedWithPackingList ? (
                    <div>
                        <Label text="COMMENT_LABEL_7" /><Input multiline value={varx.BatchesMatchedWithPackingListComment} readonly />
                    </div>
                ) : (<div></div>)}
                {batchPackingsQuestion7}
                <SectionLabel text="QUESTION_8" />
                <RadioYesNoNull text="LABEL_8" value={varx.GoodConditionOfBoxesOnArrival} aria-label="GoodConditionOfBoxesOnArrival" readonly />
                {!varx.GoodConditionOfBoxesOnArrival ? (
                    <div>
                        <Label text="COMMENT_LABEL" /><Input multiline value={varx.GoodConditionOfBoxesOnArrivalComment} readonly />
                        {/*<Label text="(pictures GoodConditionOfBoxesOnArrival UrlAttachment)" />*/}
                        {goodConditionAttachmentQuestion8}
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_9" />
                <RadioYesNoNull text="LABEL_9" value={varx.LabelsAttachedToBoxes} aria-label="LabelsAttachedToBoxes" readonly />
                {!varx.LabelsAttachedToBoxes ? (
                    <div>
                        <Label text="COMMENT_LABEL" /><Input multiline value={varx.LabelsAttachedToBoxesComment} readonly />
                        {/*<Label text="(pictures LabelsAttachedToBoxes UrlAttachment)" />*/}
                        {labelsAttachedToBoxesAttachmentQuestion9}
                    </div>
                ) : (<div></div>)}
                <SectionWithQuestionLabel text="QUESTION_10" questionText="TOOLTIP_10" /><br />
                <RadioYesNoNull text="LABEL_10" value={varx.IsAllShippingBoxesInspected} aria-label="IsAllShippingBoxesInspected" readonly />
                {!varx.IsAllShippingBoxesInspected ? (
                    <div>
                        <Label style={{ color: "red" }} text="PLEASE_INSPECT_BOXES" />
                    </div>
                ) : (<div></div>)}
                <SectionLabel text="QUESTION_11" />
                <RadioYesNoNull text="LABEL_11" value={varx.IsThereProblemsWithTemperature} aria-label="IsThereProblemsWithTemperature" readonly />
                {varx.IsThereProblemsWithTemperature != false ? (
                    <div>
                        <Label text="LABEL_11_2" /><MultipleSelect items={devices} value={varx.DeviceIds} readonly />
                        <Label text="COMMENT_BOXES" /><Input multiline value={varx.ThereProblemsWithTemperatureComment} readonly />
                    </div>
                ) : (<div></div>)}
                <SectionWithQuestionLabel text="QUESTION_12" questionText="TOOLTIP_12" /><br />
                <RadioYesNoNull text="LABEL_12" value={varx.IsThereAlarmsOrExcursionsTemperature} aria-label="IsThereAlarmsOrExcursionsTemperature" readonly />
                {varx.IsThereAlarmsOrExcursionsTemperature != false ? (
                    <div>
                        <hr />
                        {thereAlarmsOrExcursionsTempAttachmentPdfQuestion12}<hr />
                        <a href="/VarTransactions/DownloadVARAlarmReportForm" target="_blank"><BasicLabel text="Download VAR Alarm Report Form PDF" /></a><br />
                        {thereAlarmsOrExcursionsTempAttachmentAlarmQuestion12}<hr />
                        {thereAlarmsOrExcursionsTempAttachmentPicturesQuestion12}<hr />
                        <Label text="COMMENT_LABEL" /><Input multiline value={varx.ThereAlarmsOrExcursionsTemperatureComment} readonly />
                        <Label text="LABEL_12_2" /><DateTime value={varx.InsColdStoreArrivalDate ? varx.InsColdStoreArrivalDate : ToShortDate(new window.Date())} readonly />
                        <Label text="LABEL_12_3" /><Input value={varx.TemperatureAlarmShakeTestResults} readonly />
                    </div>
                    ) : (<div></div>)}
                <SectionLabel text="QUESTION_13" />
                <Label text="LABEL_13" /><Date value={varx.DateOfInspection ? varx.DateOfInspection : ToShortDate(new window.Date())} readonly />
                <SectionLabel text="QUESTION_14" />
                <RadioYesNoNull text="LABEL_14" value={varx.IsThereAnyAdditionalComments} aria-label="IsThereAnyAdditionalComments" readonly />
                {varx.IsThereAnyAdditionalComments != false ? (
                    <div>
                        <Label text="COMMENT_LABEL" /><Input multiline value={varx.OtherComments} readonly />
                    </div>
                ) : (<div></div>)}
            </ExpandableObject>
            <ExpandableObject name="INSPECTOR_SIGNATURE" onChange={() => setExpandInspector(!expandInspector)} expanded={expandInspector}>
                <Label text="NAME" />
                <Input value={varx.InspectorName ?? ""} readonly />
                <Label text="SIGNATURE_DATE" />
                {varx.ConsigneeSignatureDate ? <Date value={varx.ConsigneeSignatureDate} readonly /> : <Input value={ToShortDate(new window.Date())} readonly />}
                <Label text="EMAIL" />
                <Input value={varx.Inspector ? varx.Inspector.Email : ""} readonly />
            </ExpandableObject>
            <ExpandableObject name="AUTHORIZED_SUPERVISOR" onChange={() => setExpandSupervisor(!expandSupervisor)} expanded={expandSupervisor} styleDetail={{ padding: 0 }}>
                <div style={{ padding: 16 }}>
                    <Label text="NAME" />
                    <Input value={varx.SupervisorName ?? ""} readonly />
                    <Label text="EMAIL" />
                    <Input value={supervisor ? supervisor.Email : ""} readonly />
                </div>
            </ExpandableObject>
            <ExpandableObject name="REFER_BACK_HISTORY" onChange={() => setExpandReferBackHistory(!expandReferBackHistory)} expanded={expandReferBackHistory}>
                <ReferBackHistory varId={varId} />
            </ExpandableObject>
            <br />
            <br />
            {editButton ?
                <React.Fragment>
                    <AppBar position="fixed" color="primary" className={`${classes.appBar} ${classes.sectionMobile}`}>
                        <Toolbar style={{ height: 60, textAlign: "center", padding: 0 }}>
                            <Link to={`/${caller}/edit/${varx.Id}`} className={classes.button} style={{ textDecoration: "none" }}><BasicLabel text="EDIT"/></Link>
                        </Toolbar>
                    </AppBar>
                    <Grid container item xs={12} justifyContent="center" style={{ marginTop: "1rem" }}>
                        <Link to={`/${caller}/edit/${varx.Id}`} className={`${classes.sectionDesktopBottom} ${classes.button}`} style={{ padding: 0, lineHeight: '3em', textDecoration: "none" }}><BasicLabel text="EDIT" /></Link>
                    </Grid>
                </React.Fragment>
                : ""}
            <br />
        </div>
    )
}

export const VarPage = ({ match }) => {
    const { varId, /*callingPage*/ } = match.params

    const varx = useSelector(state => selectVarById(state, varId))

    const dispatch = useDispatch()

    let varStatus = useSelector((state) => state.singleVar.status)
    const error = useSelector((state) => state.singleVar.error)

    //@todo: gestire una scadenza della risorsa?
    if (!varx) {
        varStatus = 'idle'
    }

    useEffect(() => {
        if (varStatus === 'idle') {
            dispatch(fetchVar(varId))
        }
    }, [varStatus, dispatch, varId])

    let content, contentTitle

    if (varStatus === 'loading') {
        content = <div className="loader"></div>
        contentTitle = 'Loading VAR...'
    } else if (varStatus === 'succeeded') {
        content = <VarForm key={varId} varId={varId} />
        contentTitle = 'VIEW_VAR'
    } else if (varStatus === 'error') {
        contentTitle = 'Error loading VAR'
        content = <div>{error}</div>
    }

    return (
        <section>
            <br />
            <h2 className="text-center"><BasicLabel text={contentTitle} />{varStatus === 'succeeded' ? ` ${varx.VarreportCode}` : ''}</h2>
            <br />
            {content}
        </section>
    )
}
